import EntityModel from '@/common/models/entity-model';

export default class CredentialItemModel extends EntityModel {
    hydrate({
        id = null,
        name = null,
    } = {}) {
        this.id = id;
        this.name = name;
    }

    toSelectOption() {
        return {
            value: this.id,
            label: this.name,
        };
    }
}
